/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrganisationRole
 */
export interface OrganisationRole {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   * The username of a user
   */
  user: string;
  /**
   *
   */
  role: string;
  /**
   * The unique_id of an organisation
   */
  organisation: string;
  /**
   *
   */
  readonly organisationName?: string;
}

/**
 * Check if a given object implements the OrganisationRole interface.
 */
export function instanceOfOrganisationRole(value: object): value is OrganisationRole {
  if (!("user" in value) || value["user"] === undefined) return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  if (!("organisation" in value) || value["organisation"] === undefined) return false;
  return true;
}

export function OrganisationRoleFromJSON(json: any): OrganisationRole {
  return OrganisationRoleFromJSONTyped(json, false);
}

export function OrganisationRoleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrganisationRole {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    user: json["user"],
    role: json["role"],
    organisation: json["organisation"],
    organisationName: json["organisation_name"] == null ? undefined : json["organisation_name"],
  };
}

export function OrganisationRoleToJSON(json: any): OrganisationRole {
  return OrganisationRoleToJSONTyped(json, false);
}

export function OrganisationRoleToJSONTyped(
  value?: Omit<OrganisationRole, "id" | "url" | "organisationName"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user: value["user"],
    role: value["role"],
    organisation: value["organisation"],
  };
}
